import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useFlightTypeContext } from 'src/contexts/flight-type.context';
import { actionTypes } from 'src/ducks/flight-type.duck';
import { IFlightType, IFlightTypeForm } from 'src/models/flight-type.model';
import { getFlightTypeStatus } from 'src/selectors/flight-type.selector';
import FlightTypeForm from '../flight-types-form/flight-types-form.component';
import style from '../flight-types-list/flight-types-list.module.scss';

const FlightTypeAdd: React.FC = () => {
  const { state, actions } = useFlightTypeContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IFlightType> = {
    flightType: '',
  };

  const addStatus = getFlightTypeStatus(state, actionTypes.FLIGHT_TYPE_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: IFlightTypeForm = {
        flightType: data.flightType,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_FLIGHT_TYPE_ADD_SUCCESS,
            formData.flightType ? formData.flightType : data.tailNumber
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_FLIGHT_TYPE}
      content={
        <div className={style.content}>
          <FlightTypeForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FlightTypeAdd;
